export default __webpack_public_path__ + "img/stars.908e76137954ad898d3d41ba2abffe4b.svg";